<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-school_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk" v-if="id">教場管理</p>
      <p class="title-bk" v-else>教場ID管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'school' : 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit" v-show="allowEditingSchool">
                編集
              </button>
              <button v-if="!id" type="button" class="btn btn-edit" @click="goToVideoViewingPage">
                映像視聴ID管理
              </button>
              <button type="button" class="btn" @click="changePassword">
                パスワード変更
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場ID</th>
            <td>{{ currentSchool.uid }}</td>
          </tr>
          <tr>
            <th scope="row">教場名</th>
            <td>{{ currentSchool.name }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（フリガナ）</th>
            <td>{{ currentSchool.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentSchool.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentSchool.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentSchool.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentSchool.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentSchool.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentSchoolEmail }}</td>
          </tr>
          <tr>
            <th scope="row">利用教材</th>
            <td>{{ currentSchoolProducts }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import {
  basicPresent,
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicProductName,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('school/fetchSchool', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingSchool();
  },
  computed: {
    currentSchool() {
      return this.school.school;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentSchool.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentSchool.brand);
    },
    currentSchoolEmail() {
      return basicPresent(this.currentSchool.email);
    },
    currentSchoolProducts() {
      return basicProductName(this.currentSchool.figuredProducts);
    },
    ...mapState(['school']),
    ...mapGetters('role', ['allowEditingSchool']),
  },
  methods: {
    edit() {
      if (this.id) {
        this.$logger.debug('Edit School ID ' + this.id);
        this.$router.push({ name: 'school-id-edit', params: { id: this.id } });
      }
    },
    changePassword() {
      if (this.id) {
        this.$logger.debug('Change Password ID ' + this.id);
        this.$router.push({ name: 'school-id-change-password', params: { id: this.id } });
      } else {
        this.$logger.debug('Change Password');
        this.$router.push({ name: 'school-change-password' });
      }
    },
    goToVideoViewingPage() {
      this.$logger.debug('goToEditVideoRolePage ' + this.currentSchool.id);
      this.$router.push({ name: 'school-id-video-viewing', params: { id: this.currentSchool.id, isSchool: true } });
    },
    ...mapActions('school', ['clearEditingSchool']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
